var map = {
	"./de/general1/slide1.svg": 675774,
	"./en/general1/slide1.svg": 876186,
	"./es/general1/slide1.svg": 1319,
	"./fr/general1/slide1.svg": 463039,
	"./nl/general1/slide1.svg": 91737,
	"./pt/general1/slide1.svg": 695675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806624;